/* eslint id-length: "off" */
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faApple,
  faBandcamp,
  faDeezer,
  faSpotify,
  faTidal,
} from "@fortawesome/free-brands-svg-icons";
import {faBuildingColumns} from "@fortawesome/free-solid-svg-icons";
import MDMusicArtwork from "@/components/music/md-player/MDMusicArtwork";
import {SOURCE_LABELS} from "@/lib/music/parseTracks";
import {fmtDuration} from "@/lib/music/format";

// Source glyph per chip. Sources without an entry (e.g. "md") show no chip.
const SOURCE_BRAND_ICON = {
  am: faApple,
  bc: faBandcamp,
  dz: faDeezer,
  ia: faBuildingColumns,
  sp: faSpotify,
  ti: faTidal,
};

const PlaylistRow = ({active, onSelect, track}) => {
  const brandIcon = SOURCE_BRAND_ICON[track.source];
  return (
    <button className={`panel-block mdmusic-row${active ? " is-active" : ""}`}
            type="button"
            onClick={onSelect}
    >
      <span className="mdmusic-row-art">
        <MDMusicArtwork size="thumb" track={track}/>
      </span>
      <span className="mdmusic-row-text">
        <span className="mdmusic-row-title">{track.trackName}</span>
        <span className="mdmusic-row-artist is-size-7 has-text-grey">
          {track.artistName}
        </span>
      </span>
      {brandIcon && (
        <span className="icon mdmusic-row-brand"
              title={SOURCE_LABELS[track.source]}
        >
          <FontAwesomeIcon icon={brandIcon}/>
        </span>
      )}
      <span className="is-size-7 has-text-grey mdmusic-row-duration">
        {fmtDuration(track.durationMs)}
      </span>
    </button>
  );
};

PlaylistRow.propTypes = {
  active: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  track: PropTypes.shape({
    trackName: PropTypes.string.isRequired,
    artistName: PropTypes.string.isRequired,
    durationMs: PropTypes.number,
    source: PropTypes.string.isRequired,
  }).isRequired,
};

const MDMusicPlaylist = ({activeIndex, onSelect, tracks}) => (
  <nav aria-label="Playlist" className="panel mdmusic-playlist">
    {tracks.map((track, idx) => (
      <PlaylistRow key={`${track.source}-${track.ids.track}`}
                   active={idx === activeIndex}
                   track={track}
                   onSelect={() => onSelect(idx)}
      />
    ))}
  </nav>
);

MDMusicPlaylist.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  tracks: PropTypes.array.isRequired,
};

export default MDMusicPlaylist;
